/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ActivitySnapshotBase = zod.object({
  "type": zod.union([zod.enum(['datetime', 'reference', 'reference_set']),zod.string()]),
  "field": zod.string(),
  "label": zod.string()
});

export type ActivitySnapshotBase = zod.input<typeof ActivitySnapshotBase>;
export type ActivitySnapshotBaseOutput = zod.output<typeof ActivitySnapshotBase>;
